import { render, staticRenderFns } from "./CancelBooking.vue?vue&type=template&id=52c18dc0&scoped=true"
import script from "./CancelBooking.vue?vue&type=script&lang=js"
export * from "./CancelBooking.vue?vue&type=script&lang=js"
import style0 from "./CancelBooking.vue?vue&type=style&index=0&id=52c18dc0&prod&lang=css"
import style1 from "./CancelBooking.vue?vue&type=style&index=1&id=52c18dc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c18dc0",
  null
  
)

export default component.exports